<template>
  <div v-loading="loading">
    <div class="live_text_content" v-if="liveDataList.length > 0">
      <span class="icon_circle_header"></span>
      <span class="icon_circle_footer"></span>
      <dl class="match_progress" v-for="(item, index) of liveDataList" :key="index">
        <dt>{{ item.time }}</dt>
        <dd>
          <!--足球文字直播没有比分数据-->
          <h4 v-show="false" class="score">{{ item.home_score }}-{{ item.away_score }}</h4>
          <div class="content">{{ item.data }}</div>
          <span v-show="item.position == 1" class="team_red"></span>
          <span v-show="item.position == 2" class="team_blue"></span>
        </dd>
      </dl>
    </div>
    <div v-if="liveDataList.length == 0 && loading == false">
      <panel-not-data message="当前赛事没有文字直播数据..." img-name="queue" />
    </div>
  </div>
</template>

<script>
//引入公用无数据组件
import PanelNotData from "@/components/match-recommend/not-data";

export default {
  name: "FballText",
  data() {
    return {
      //加载动画
      loading: true,
      //文字直播数据
      liveDataList: [],
    };
  },
  components: {
    PanelNotData,
  },
  mounted() {
    //增加强行关闭动画的定时器
    setTimeout(() => {
      this.loading = false;
    }, 20000);
  },
  methods: {
    /**
     * 关键事件内容处理
     * @param {string} ret_data 接口发过来的json字符串
     */
    runData(ret_data) {
      let live_data_list = JSON.parse(ret_data.replace(/[\\]+/g, "").slice(1, -1));
      // console.log("main=1是关键事件，仅针对足球:", live_data_list);
      if (live_data_list.length > 0) {
        console.log("main=1是关键事件，仅针对足球:", live_data_list);
        this.liveDataList = live_data_list[0].text_live.reverse();
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./live_text.scss";
</style>